// extracted by mini-css-extract-plugin
module.exports = {"btn":"SubmitButton_btn__xU6fh","submitting":"SubmitButton_submitting__vX-Fb","img":"SubmitButton_img__NY7o4"};